import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebaseConfig';
import { clearUser } from '../store/userSlice';
import { Box, Typography, Button, Avatar, Paper } from '@mui/material';
import { useGetUserProfileQuery } from '../store/docApi';

export default function Profile() {
  const userData = useSelector((state) => state.user.userData);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: profile } = useGetUserProfileQuery();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      dispatch(clearUser());
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error.message);
    }
  };

  if (!userData) {
    return (
      <Paper
        elevation={3}
        sx={{
          maxWidth: 400,
          mx: 'auto',
          my: 4,
          py: 3,
          px: 2,
          borderRadius: 2,
          textAlign: 'center'
        }}
      >
        <Typography variant="h5" gutterBottom>
          You are not logged in.
        </Typography>
        <Button variant="contained" color="primary" onClick={() => navigate('/login')} sx={{ mt: 2 }}>
          Go to Login
        </Button>
      </Paper>
    );
  }

  return (
    <Paper
      elevation={3}
      sx={{
        maxWidth: 400,
        mx: 'auto',
        my: 4,
        py: 3,
        px: 2,
        borderRadius: 2,
        textAlign: 'center'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Avatar
          src={profile?.picture || userData.photoURL || ''}
          alt={profile?.name || userData.email}
          sx={{ width: 80, height: 80, mb: 2 }}
        >
          {(profile?.name || userData.email)[0].toUpperCase()}
        </Avatar>
        <Typography variant="h5" gutterBottom>
          {profile?.name || userData.email}
        </Typography>
        <Typography variant="body1" color="text.secondary" gutterBottom>
          {userData.email}
        </Typography>
        <Button variant="contained" color="primary" onClick={handleLogout} sx={{ mt: 4, width: '100%' }}>
          Logout
        </Button>
      </Box>
    </Paper>
  );
}
